import { ACTIVATION_BRIEF_STATUS_NONE, ACTIVATION_BRIEF_STATUS_IN_REVIEW, ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL, ACTIVATION_BRIEF_STATUS_ACCEPTED, ACTIVATION_BRIEF_STATUS_DECLINED, ACTIVATION_BRIEF_STATUS_COMPLETE } from './activation-brief';
import { NAME_PRODUCTS, NAME_BRAND_ASSETS, NAME_COMPENSATION, NAME_CONTENT_AGREEMENT, NAME_NETWORKS, NAME_SHIPPING_INFO, NAME_PERSONAL_INFO, NAME_TASKS, NAME_UPLOAD_FILES } from './activation-brief-steps';
export const STEP_ORDERS = {
    [ACTIVATION_BRIEF_STATUS_NONE]: [
        NAME_COMPENSATION,
        NAME_PRODUCTS,
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_NETWORKS,
        NAME_SHIPPING_INFO,
        NAME_PERSONAL_INFO,
        NAME_BRAND_ASSETS,
        NAME_CONTENT_AGREEMENT
    ],
    [ACTIVATION_BRIEF_STATUS_IN_REVIEW]: [
        NAME_COMPENSATION,
        NAME_PRODUCTS,
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_NETWORKS,
        NAME_SHIPPING_INFO,
        NAME_PERSONAL_INFO,
        NAME_BRAND_ASSETS,
        NAME_CONTENT_AGREEMENT
    ],
    [ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL]: [
        NAME_COMPENSATION,
        NAME_PRODUCTS,
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_NETWORKS,
        NAME_SHIPPING_INFO,
        NAME_PERSONAL_INFO,
        NAME_BRAND_ASSETS,
        NAME_CONTENT_AGREEMENT
    ],
    [ACTIVATION_BRIEF_STATUS_DECLINED]: [
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_PRODUCTS,
        NAME_NETWORKS,
        NAME_COMPENSATION,
        NAME_BRAND_ASSETS,
        NAME_SHIPPING_INFO,
        NAME_PERSONAL_INFO,
        NAME_CONTENT_AGREEMENT
    ],
    [ACTIVATION_BRIEF_STATUS_ACCEPTED]: [
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_PRODUCTS,
        NAME_NETWORKS,
        NAME_COMPENSATION,
        NAME_BRAND_ASSETS,
        NAME_PERSONAL_INFO,
        NAME_CONTENT_AGREEMENT
    ],
    [ACTIVATION_BRIEF_STATUS_COMPLETE]: [
        NAME_TASKS,
        NAME_UPLOAD_FILES,
        NAME_PRODUCTS,
        NAME_NETWORKS,
        NAME_COMPENSATION,
        NAME_BRAND_ASSETS,
        NAME_PERSONAL_INFO,
        NAME_CONTENT_AGREEMENT
    ]
};
